import "./styles/tailwind.css";
import axios from "axios";
import * as v from "valibot";
import "@valibot/i18n/zh-CN";
import { createApp } from "./app";
import { setupDayjs } from "./dayjs";
import { setServices } from "@kce2/common/core/baseinfo";
import { getRegions, checkProductPermission } from "@kce2/common/api/commons";
import { checkAuthorization } from "@kce2/common/core/request";
import { registerKsDocHandler } from "./common/utils/ksStorage";
import { validateResponsePlugin, assignRequestIdPlugin } from "./common/api/axios";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
import { setupMonacoEditor } from "./monaco-editor";
import { preload } from "./preload";
import { setupForm } from "./form";
import { ENABLE_AI_ASSISTANT } from "./feature_flags";
import "./shim";

v.setGlobalConfig({ lang: "zh-CN" });

setupForm();

setupMonacoEditor();
setupDayjs();
checkAuthorization(axios);
validateResponsePlugin(axios);
assignRequestIdPlugin("X-KSC-Request-Id")(axios);

window.__KSC_APP_VERSION__ = {
  ...(window.__KSC_APP_VERSION__ || {}),
  commit: __COMMIT__,
  builttime: __BUILTTIME__,
  // APP_ID: KCE_ORDER_APP_ID,
};

// 异步加载 yaml 并暴露到全局（用于调试）
import("yaml").then(({ default: yaml }) => {
  (window as any).yamljs = yaml;
});

setServices({
  getRegions: getRegions,
  checkProductPermission: checkProductPermission,
});

registerKsDocHandler({
  indexUrl: "//docs.ksyun.com/products/46",
  indexEnUrl: "//endocs.ksyun.com/en/products/46",
});

preload();
createApp("#app");

if (ENABLE_AI_ASSISTANT) {
  window.requestIdleCallback(
    () => {
      import("./ai-assistant").then(mod => mod.setupAiAssistant());
    },
    { timeout: 2000 },
  );
}

if (__DEV__) {
  import("lodash-es").then(v => ((window as any)._ = v));
}
